import React from 'react'
import StyleSheet from 'styles'
import { baseTheme } from 'styles'
import classnames from 'classnames'

export default function CenteredContent (props) {
  const { className } = props
  const classes = classnames(styles.centeredContent, className)

  return (
    <div className={ classes } style={props.style}>
      { props.children }
    </div>
  )
}

const styles = StyleSheet({
  centeredContent: {
    maxWidth: baseTheme.siteStyleguide.maxWidth,
    width: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
    padding: [50, 40, 70],
    '@media(max-width: 600px)': {
      padding: 20,
    },
    '@media print': {
      paddingLeft: '0',
      paddingRight: '0',
      padding: [25, 0, 10],
    },
    '& h5': {
      marginBottom: 40,
      '@media print': {
        marginBottom: 8
      },
      '@media(max-width: 600px)': {
        marginBottom: 15
      }
    },
  }
})
